import { useState } from 'react';
import styled from 'styled-components';

import imagemDer from '../../assets/imagensDERs/sisafDerModuloHome.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  text-align: justify;
  padding: 5px;

  ul {
    margin-bottom: 15px;
  }
`;

const Definicao = styled.div`
  margin-bottom: 20px;
`;

const AbasContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #b0c4de;
  margin-bottom: 15px;
`;

const Aba = styled.div<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  background-color: ${({ active }) => (active ? '#869ddb83' : 'transparent')};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &:hover {
    background-color: #b0c4de;
  }
`;

const ImagemDer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid lightgray;
  background-color: lightgray;
  margin-bottom: 25px;

  img {
    height: 30vh;
    border-radius: 10px;
    width: auto;

    transition: transform 0.3s ease-in-out;

    &:hover {
      /* transform: scale(1.5); */
    }
  }
`;

const AbaDefinicoes = () => {
  return (
    <>
      <ul>
        <li>
          <b>Principais Números</b>
        </li>
        <ul>
          <li>
            Números gerais de itens importantes do SisAF como: (a) Nº de
            Produtos Farmacêuticos, (b) Nº de Fornecedores, (c) Nº de Processos
            Aquisitivos em andamento e (d) Nº de Contratos Vigentes.
          </li>
        </ul>

        <li>
          <b>Glossário</b>
        </li>
        <ul>
          <li>
            O Glossário é uma ferramenta que reúne e organiza os principais
            termos técnicos utilizados no dia a dia das atividades do DAF. Seu
            objetivo é facilitar o entendimento e a comunicação entre as
            equipes, assegurando que todos os envolvidos compartilhem uma
            compreensão comum sobre conceitos, processos e funções essenciais.
          </li>
        </ul>
      </ul>
    </>
  );
};

const Entidades = () => {
  return (
    <>
      <ImagemDer>
        <img src={imagemDer}></img>
      </ImagemDer>

      <b>Entidade</b>
      <ul>
        <li>
          <b>TB_GLOSSARIO</b>
        </li>
        <ul>
          <li>
            Entidade que concentra as informações de termos técnicos do DAF.
          </li>
        </ul>
      </ul>
    </>
  );
};

const RegrasDeNegocio = () => {
  return (
    <>
      <ul>
        <li>
          <b>Glossário</b>
        </li>
        <ul>
          <li>
            Não pode ter dois ou mais registros com o mesmo <b>Termo Técnico</b>
          </li>
        </ul>
      </ul>
    </>
  );
};

const AjudaModuloHome = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    'definicoes' | 'regras' | 'entidades'
  >('definicoes');

  return (
    <Container>
      <Definicao>
        Módulo que <b>apresenta informações gerais do SisAF,</b> incluindo os
        principais números e informes ativos. Além disso, conta com um{' '}
        <b>Glossário</b> que reúne e explica os principais termos técnicos
        utilizados no cotidiano das atividades do DAF.
      </Definicao>

      {/* Abas */}
      <AbasContainer>
        <Aba
          active={abaAtiva === 'definicoes'}
          onClick={() => setAbaAtiva('definicoes')}
        >
          Definições
        </Aba>
        <Aba
          active={abaAtiva === 'entidades'}
          onClick={() => setAbaAtiva('entidades')}
        >
          Entidades
        </Aba>
        <Aba
          active={abaAtiva === 'regras'}
          onClick={() => setAbaAtiva('regras')}
        >
          Regras de Negócio
        </Aba>
      </AbasContainer>

      {/* Conteúdo da Aba Ativa */}
      {abaAtiva === 'definicoes' ? (
        <AbaDefinicoes />
      ) : abaAtiva === 'regras' ? (
        <RegrasDeNegocio />
      ) : (
        <Entidades />
      )}
    </Container>
  );
};

export default AjudaModuloHome;
